var mapStyle = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#46bcec"
            },
            {
                "visibility": "on"
            }
        ]
    }
]
var AppConstants = {}

AppConstants.install = function (Vue, options) {
  Vue.prototype.appConstants = {
    mapStyle: mapStyle,
    facebook: 'https://www.facebook.com/nearbuyfribourg/',
    twitter: 'http://www.twitter.com',
    instagram: 'http://www.instagram.com',
    translations: {
        fr: {
            navigation: {
                home: "Accueil",
                howItWorks: "Comment ça marche",
                future: "Nos projets",
                team: "L’équipe",
                contact: "Contact",
                sellProducts: "Vendre des produits"
            },
            home: {
                main_heading: "Du contrôle pour les producteurs & de la transparence pour les consommateurs",
                head_tags_1: "#Local",
                head_tags_2: "#Prix juste",
                head_tags_3: "#Consommation responsable",
                sub_heading: "Un outil qui facilite les transactions transparentes et justes entre les producteurs locaux et les consommateurs responsables",
                app_stores_buttons: "Obtenez-le de"
            },
            howItWorks: {
                page_title: "Comment ça marche?",
                page_heading: "Notre application web et notre application mobile (apple & android) font de Near-Buy un outil simple d’utilisation",
                producers_tab: "Producteur local",
                consumers_tab: "Consommateur responsable",
                producer_boxes: {
                    box_1: {
                        box_title: "Rejoindre la plateforme",
                        box_point_1: "S’inscrire sur Near-Buy",
                        box_point_2: "Attendre que Near-Buy active le compte",
                    },
                    box_2: {
                        box_title: "Insérer les produits",
                        box_point_1: "Ecrire ce qui est en vente, et à quel prix",
                        box_point_2: "Suggérer des produits qui ne sont pas dans nos listes",
                    },
                    box_3: {
                        box_title: "Imprimer les codes QR",
                        box_point_1: "Cliquer pour obtenir les codes QR",
                        box_point_2: "Placer les codes QR pour que les consommateurs puissent les scanner et vous payer directement",
                    },
                },
                consumer_boxes: {
                    box_1: {
                        box_title: "Installer l’app Near-Buy",
                        box_point_1: "Aller sur l’app store (iOS ou Android), et téléchargez le <<Near-Buy Shop>> app",
                        box_point_2: "Créez votre compte, connectez-vous et utilisez l'application",
                    },
                    box_2: {
                        box_title: "Trouver le shop près de chez soi",
                        box_point_1: "Chercher sur la carte le shop près de chez soi",
                        box_point_2: "Visiter ce shop & se servir de ce qu’on a besoin",
                    },
                    box_3: {
                        box_title: "Scanner & payer directement le producteur",
                        box_point_1: "Scanner les codes QR",
                        box_point_2: "Payer directement chaque producteur",
                    },
                },
            },
            nearBuyFuture: {
                page_title: "Les projets de Near-Buy",
                page_heading: "A l'écoute des besoins des producteurs et des consommateurs, Near-Buy développera de nouvelles fonctionnalités dans ses applications pour promouvoir le terroir.",
                future_1: "Multiplier les points de ventes",
                future_2: "Service de livraison",
                future_3: "Near-Buy pour les restaurants"
            },
            team: {
                page_title: "L’équipe",
                page_heading: "Near-buy s'est fixé les objectifs suivants : réduire les déchets alimentaires, promouvoir l’alimantation locale et garantir la transparence des informations. Ces défis ont été initiés par quatre passionnés.",
                memberRole: "Co-fondateur"
            },
            contact: {
                page_title: "Nous dire coucou!",
                page_heading: "Si vous avez des questions sur Near-Buy et sa philosophie, n'hésitez pas à nous contacter.",
                contactForm: {
                    name: "Nom",
                    email: "Courriel",
                    message: "Votre message",
                    sendButton: "Envoyer le message"
                }
            },
            map: {
                farmerTotal: 'Farmers in Total',
                filterProduct: 'Products',
                filterZipCode: 'Postal Code',
                address: 'Address',
                tel: 'Tel',
                email: 'Email',
                website: 'Website',
                products: 'Products',
                workingHours: 'Opening Time',
                bio: 'Description',
                filter: 'Filter',
            }
        },
        en: {
            navigation: {
                home: "Home",
                howItWorks: "How it works",
                future: "Future",
                team: "Team",
                contact: "Contact",
                sellProducts: "Sell products"
            },
            home: {
                main_heading: "Control to producers & transparency to consumers",
                head_tags_1: "#Local",
                head_tags_2: "#Fair prices",
                head_tags_3: "#Responsbile use",
                sub_heading: "A tool that facilitates transparent and fair transactions between local producers and responsible consumers",
                app_stores_buttons: "Get It From"
            },
            howItWorks: {
                page_title: "How it works?",
                page_heading: "Web and mobile (iOS & Android) apps make Near-Buy easy to use",
                producers_tab: "Local producer",
                consumers_tab: "Responsbile consumer",
                producer_boxes: {
                    box_1: {
                        box_title: "Join the platform",
                        box_point_1: "Register on Near-Buy web app",
                        box_point_2: "Wait for the Near-Buy to activate your account",
                    },
                    box_2: {
                        box_title: "Insert your products",
                        box_point_1: "Write what you sell and at what price",
                        box_point_2: "Suggest any product that is missing in our list",
                    },
                    box_3: {
                        box_title: "Print the QR codes",
                        box_point_1: "Click to download products' QR codes",
                        box_point_2: "Place the QR codes near products, so consumers can scan & directly pay you",
                    },
                },
                consumer_boxes: {
                    box_1: {
                        box_title: "Download Near-Buy app",
                        box_point_1: "Visit your mobile app store and download the <<Near-Buy Shop>> app",
                        box_point_2: "Create your account, login and use the app",
                    },
                    box_2: {
                        box_title: "Find the shop next-door",
                        box_point_1: "Look at the map for the shops next-door",
                        box_point_2: "Visit the shop & help yourself with what you need",
                    },
                    box_3: {
                        box_title: "Scan & pay directly the producer(s)",
                        box_point_1: "Scan the QR codes",
                        box_point_2: "Pay the producer(s) directly",
                    },
                },
            },
            nearBuyFuture: {
                page_title: "Near-Buy – Near Future",
                page_heading: "Listening to the needs of producers & consumers, Near-Buy will develop new features in its own apps to promote the terroir",
                future_1: "Many Selling Points",
                future_2: "Delivery",
                future_3: "Near-Buy for restaurants"
            },
            team: {
                page_title: "Team",
                page_heading: "Near-buy has set itself the following goals: reduce food waste, promote local food, and ensure transparency. These challenges were initiated by four enthusiasts.",
                memberRole: "Co-founder"
            },
            contact: {
                page_title: "Say Hello To Us!",
                page_heading: "If you have any questions about Near-Buy and its philosophy, feel free to contact us.",
                contactForm: {
                    name: "Name",
                    email: "E-mail",
                    message: "Message",
                    sendButton: "Send message",
                }
            },
            map: {
                farmerTotal: 'Farmers in Total',
                filterProduct: 'Products',
                filterZipCode: 'Postal Code',
                address: 'Address',
                tel: 'Tel',
                email: 'Email',
                website: 'Website',
                products: 'Products',
                workingHours: 'Opening Time',
                bio: 'Description',
                filter: 'Filter',
            }            
        },
        de: {
            page_title: "Home",
        }
    }
 }
}

export default AppConstants


// WEBPACK FOOTER //
// ./src/constants.js